import { Component, OnInit } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { DataserviceService } from '../dataservice.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AppComponent } from '../app.component';

type NzSortOrder = 'ascend' | 'descend' | null;

@Component({
  selector: 'app-disposition-control',
  templateUrl: './disposition-control.component.html',
  styleUrl: './disposition-control.component.css'
})
export class DispositionControlComponent implements OnInit {
  isLoading = false;
  currentUser: any;
  dispositions: any[] = [];
  total: number = 0;
  pageSize = 100;
  pageIndex = 1;
  sortField = 'disposition_date';
  sortOrder: NzSortOrder = 'ascend';
  selectedProvider: any;
  availableProviders: any[] = [];


  constructor(private data: DataserviceService,
    private message: NzMessageService,
    private app: AppComponent,
    private modal: NzModalService
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('user')!);
  }

  ngOnInit(): void {
    this.getProviders();
  }

  getProviders() {
    if (!this.currentUser.id) {
      console.error("No User ID found");
      return;
    }

    const url = `providers/providers-by-user/${this.currentUser.id}`;

    this.data.getData(url).subscribe((res: any) => {
      if (res.result === 'success') {
        this.availableProviders = res.data;
      } else {
        this.message.error(res.message);
      }
    });
  }

  getData() {
    this.isLoading = true;

    if (!this.selectedProvider) {
      this.message.warning('Please select a provider first');
      this.isLoading = false;
      return;
    }

    const url = `disposition/dispositions-by-provider-list/${this.selectedProvider}`;

    this.data.getData(url).subscribe((res: any) => {
      if (res.result === 'success') {
        this.dispositions = res.data;
        this.total = res.data.length;
      } else {
        this.message.error(res.message);
      }
      this.isLoading = false;
    });
  }

  toggleDisposition(disp: any) {
    this.isLoading = true;
    const newStatus = disp.da_status === 'active' ? 'inactive' : 'active';

    const payload = {
      id: disp.id,
      status: newStatus,
      provider_id: disp.provider_id
    };

    // Using the corrected method name and argument order
    this.data.postDataNoBodyDotBody(payload, 'disposition/toggle-disposition').subscribe((res: any) => {
      if (res.result === 'success') {
        this.message.success('Status updated');
        this.getData(); // Refresh table
        this.isLoading = false;
      } else {
        this.message.error(res.message);
        this.isLoading = false;
      }
    });
  }
  // we gonna have a drop down filter based on the providers a company that can sell (that can go in the filter area)
  // that will bring up a list of ALLLLLLL dispositions for that provider
  // if the disposition for the provider and for the company does not exist in the disposition assignment then we'll assume thats an active disposition
  // we gonna have a toggle for each disposition that will change the status between active and inactive
  // 
}
